import {builderState} from './builder.state';
import {
    Expression, ExpressionWrapper, isLogicalExpression, isComparisonExpression,isLiteralExpression,
    isSetComparisonExpression,isSetComparisonOperator,isRangeComparisonOperator,isUnaryComparisonOperator, isRangeComparisonExpression, isUnaryComparisonExpression,isFunctionExpression,
    isStringComparisonExpression,isDataFieldPathExpression,isLeftOperandOnly,SqlFunction
} from './types2';

let literalExpressionObj =
{
  "operator": "=",
  "leftOperand": {
    "literalValue": ""
  },
  "rightOperand": {
    "literalValue": ""
  }
}
let dataFieldPathExpressionObj = 
{
  "operator": "=",
  "leftOperand": {
    "dataFieldPath": ""
  },
  "rightOperand": {
    "dataFieldPath": ""
  }
}


let functionsExpressionObj = {
    "operator":"=",
    "leftOperand": {
        "fxName": 'COALESCE',
        "fxArgs": []
    },
    "rightOperand": {
      "literalValue": ""
    }
}


let cwtBranchExpressionObj =
{
    "conditionOperand": {
        "operator": "WHEN",
        "operand": {
            ...dataFieldPathExpressionObj
        }
    },
    "resultOperand": {
        "operator": "THEN",
        "operand": {
           "literalValue": ""
        }
    }
}

let cwtExpressionObj =  {
    "operator": "CASE",
    "branchOperand": [
       {...cwtBranchExpressionObj} 
    ],
    "defaultOperand": {
        "literalValue": ""
    }
}

let cwtExpressionObjExpression =  {
    "operator": "=",
  "leftOperand": {...cwtExpressionObj},
  "rightOperand": {
    "literalValue": ""
  }
}


let logicalAndExpressionObj = {
    "operator": "AND",
    "operands": []
}
let logicalOrExpressionObj = {
    "operator": "OR",
    "operands": []
}

let unaryObj={
    "operator": "+",
    "operand": {
        "literalValue": ""
    }
}

let unaryArithmeticExpressionObj =
{
  "operator": "=",
  "leftOperand": {
    ...unaryObj
},
  "rightOperand": {
    "literalValue": ""
  }
}



export default class BuilderInteractor {

    constructor() {

    }

    
    setExpression(expression: any) {
        console.log('Setting expression:', expression);
        builderState.setExpression(expression);
    }
    getExpression() {
        return builderState.getExpression();
    }
    updateOperator(path: string[], newOperator: string) {
        console.log('Updating operator:', path, newOperator);
        try {
            builderState.updateOperator(path, newOperator);
            if(isSetComparisonOperator(newOperator) )
            {
                builderState.updateRightOperand(path, "rightOperands",{ literalValue: "" })
            }
            else if(isRangeComparisonOperator(newOperator)){
                builderState.updateRightOperand(path, "rightOperands",{ literalValue: "" })
                builderState.resetToRangeComparisonOperators(path,{ literalValue: "" })
            }
            else if(isUnaryComparisonOperator(newOperator)){
                builderState.resetToUnaryComparisonOperator(path)
            }
            else{
                builderState.updateRightOperand(path, "rightOperand",{ literalValue: "" })     
            }

        } catch (error) {
            console.error('Error updating operator:', error);
            throw error;
        }
    }
    resetExpression() {
        builderState.resetExpression();
    }
    updateDataType(path: string[], newValue: string) {
        builderState.updateDataType(path, newValue);
    }

    updateUnaryOperator(path: string[], newOperator: string) {
        builderState.updateOperator(path, newOperator);
    }

    addOperand(path: string[], type: string) {
        console.log('Adding operand:', path, type);
        let obj: any;
        
        // Match the type case-insensitively
        switch (type.toLowerCase()) {
            case "and":
                obj = logicalAndExpressionObj;
                break;
            case "or":
                obj = logicalOrExpressionObj;
                break;
            case "datafieldpath":
                obj = dataFieldPathExpressionObj;
                break;
            case "functions":
                obj = functionsExpressionObj;
                break;
            case "case":
                obj = cwtExpressionObjExpression;
                break;
            case "literalvalue":
                obj = literalExpressionObj;
                break;
            case "unaryarithmetic":     
                obj = unaryArithmeticExpressionObj;
                break;
            default:
                obj = literalExpressionObj;
                break;
        }
            
        builderState.addOperand(path, obj);
    }

    addLogicalExpression(operator:string){
        builderState.addLogicalExpression(operator);
    }

    addExpression(type: string) {
        let expressionObj = builderState.getExpression();
        
        // Create the new expression based on type
        let newExpr: any;
        switch (type.toLowerCase()) {
            case "and":
                newExpr = logicalAndExpressionObj;
                break;
            case "or":
                newExpr = logicalOrExpressionObj;
                break;
            case "literalvalue":
                newExpr = literalExpressionObj;
                break;
            case "datafieldpath":
                newExpr = dataFieldPathExpressionObj;
                break;
            case "function":
                newExpr = functionsExpressionObj;
                break;
            case "case":
                newExpr = cwtExpressionObjExpression;
                break;
            case "unaryarithmetic":
                newExpr = unaryArithmeticExpressionObj;
                break;
            default:
                newExpr = literalExpressionObj;
        }

        // If there's no existing expression, just set the new one
        if (!expressionObj || Object.keys(expressionObj).length === 0) {
            builderState.setExpression(newExpr);
            return;
        }

        // If the existing expression is not already a logical AND/OR
        if (!isLogicalExpression(expressionObj)) {
            // Create a new logical AND expression
            const logicalExpr = {
                operator: "AND",
                operands: [
                    expressionObj,  // Add existing expression as first operand
                    newExpr        // Add new expression as second operand
                ]
            };
            builderState.setExpression(logicalExpr);
        } else {
            // If it's already a logical expression, just add the new expression to its operands
            builderState.addOperand(["operands"], newExpr);
        }
    }
    addLiteralExpression() {
        builderState.addLiteralExpression(literalExpressionObj)
    }

    toggleUnaryLogicalObject(path: string[]) {
        builderState.toggleUnaryLogicalObject(path);
    }



    updateExpression(path: string[], newValue: any) {
        builderState.updateExpression(path, newValue);
    }

    updateExpressionInputType(path: string[], newType: any) {
        console.log('updateExpressionInputType:', path, newType);
        let newTypeOb:any
        if(newType.toLowerCase()=="datafieldpath")
            newTypeOb={ dataFieldPath: "" }
        else if(newType.toLowerCase()=="literalvalue")
            newTypeOb={ literalValue: "" }
        else if(newType.toLowerCase()=="functions")
            newTypeOb={ fxName: "",fxArgs: [] }
        else if(newType.toLowerCase()=="case")
            newTypeOb=cwtExpressionObj
        else if(newType.toLowerCase()=="unaryarithmetic")
            newTypeOb=unaryObj
        builderState.updateExpression(path, newTypeOb);
    }

    addRightOperand(path: string[]) {
        builderState.addRightOperand(path,{ literalValue: "" });
    }
    
    removeRightOperand(path: string[],index:any) {
        builderState.removeRightOperand(path,index);
    }

    removeOperand(path: string[],index:any){
        builderState.removeOperand(path,index);
    }

    addCWTBranchOperand(path: string[]){
        builderState.addCWTBranchOperand(path,cwtBranchExpressionObj);
    }

    removeCWTBranchOperand(path: string[],index:any){
        builderState.removeCWTBranchOperand(path,index);
    }


    updateFunctionsParams(path: string[], params: any[]) {
        // Initialize an empty array to hold the argument objects
        const argArr = params.map((param) => {
            // Depending on the parameter type, construct the appropriate object
            if (param.type === "string") {
                return { literalValue: "" };
            } else if (param.type === "integer") {
                return { literalValue: "",placeHolder: param.name };
            } else if (param.type === "string[]") {
                return { literalValue: ""};
            } else {
                // Handle unexpected types gracefully
                console.warn(`Unsupported parameter type: ${param.type}`);
                return null; // Or provide a fallback structure if necessary
            }
        }).filter((arg) => arg !== null); // Remove any `null` values
    
        // Update the builder state with the constructed argument array
        builderState.updateExpression(path, argArr);
    
        // Log the parameters and constructed arguments for debugging purposes
        console.log("Parameters:", params);
        console.log("Constructed Arguments:", argArr);
    }

    addFxArgs(path: string[]) {

        let newFxArgs = { literalValue: "" };
        builderState.addFxArgs(path, newFxArgs);

    }

    removeFxArgs(path: string[], index: number) {
        console.log('Removing fxArgs:', path, index);
        builderState.removeFxArgs(path, index);
    }
    

    findExpressionForOperator(operator: string){

    }

    updateRightOperandsDataType(path: string[], dataType: string) {
        const expr = builderState.getExpressionAtPath(path);
        
        // Update rightOperand if it exists
        if (expr.rightOperand) {
            builderState.updateDataType([...path, "rightOperand", "dataType"], dataType);
        }
        
        // Update rightOperands if they exist
        if (expr.rightOperands) {
            expr.rightOperands.forEach((_: any, index: number) => {
                builderState.updateDataType([...path, "rightOperands", index.toString(), "dataType"], dataType);
            });
        }
    }

    addArithmeticOperand(path: string[]) {
        const currentExpr = builderState.getExpressionAtPath(path);
        
        if (currentExpr.operands && currentExpr.operands.length > 0) {
            // Get dataType from the last operand
            const lastOperand = currentExpr.operands[currentExpr.operands.length - 1];
            const dataType = lastOperand.dataType || "Integer Number";

            // Add new operand with literalValue and inherited dataType
            builderState.updateExpression([...path, "operands"], [
                ...currentExpr.operands,
                {
                    literalValue: "",
                    dataType: dataType
                }
            ]);

            // Update parent comparison expression's rightOperand dataType
            const parentPath = path.slice(0, -1);
            const parentExpr = builderState.getExpressionAtPath(parentPath);
            if (parentExpr && parentExpr.rightOperand) {
                builderState.updateExpression(
                    [...parentPath, "rightOperand", "dataType"],
                    dataType
                );
            }
        }
    }

    convertToArithmeticExpression(path: string[], index?: number) {
        const currentExpr = builderState.getExpressionAtPath(path);
        const dataType = currentExpr.dataType || "Integer Number";
        
        // If index is provided, convert specific operand to arithmetic expression
        if (index !== undefined && currentExpr.operands) {
            const newOperands = [...currentExpr.operands];
            newOperands[index] = {
                operator: "+",
                operands: [
                    newOperands[index],
                    {
                        literalValue: "",
                        dataType: dataType
                    }
                ]
            };
            builderState.updateExpression([...path, "operands"], newOperands);
            return;
        }

        // Create new arithmetic expression
        const newExpr = {
            operator: "+",
            operands: [
                currentExpr,
                {
                    literalValue: "",
                    dataType: dataType
                }
            ]
        };
        
        builderState.updateExpression(path, newExpr);
    }

    updateArithmeticOperator(path: string[], operator: string) {
        builderState.setArithmeticOperator(path, operator);
    }

    removeArithmeticOperand(path: string[], index: number) {
        const currentExpr = builderState.getExpressionAtPath(path);
        
        if (currentExpr.operands) {
            const newOperands = [...currentExpr.operands];
            newOperands.splice(index, 1);
            
            // Update the expression with new operands
            builderState.updateExpression([...path, "operands"], newOperands);
        }
    }

    resetToComparisonExpression(path: string[]) {
        const currentExpr = builderState.getExpressionAtPath(path);
        if (currentExpr.operands?.[0]) {
            // Use first operand as the new expression
            builderState.updateExpression(path, currentExpr.operands[0]);
        }
    }

}